import { Map } from 'lucide-react';

// 3D view is disabled: the toggle now renders a single 2D indicator. The 3D
// button (and its Cesium mount in App) was hidden on 2026-07-14 per product.
export function ViewToggle() {
  return (
    <div className="bg-schist rounded-lg shadow-lg shadow-black/20 p-1 flex">
      <div className="p-2 rounded-md bg-basalt text-limestone flex items-center gap-1.5" title="Vista 2D">
        <Map size={18} />
        <span className="text-xs font-medium">2D</span>
      </div>
    </div>
  );
}
